import { Controller } from "@hotwired/stimulus"

// Remembers "who is writing" per browser in localStorage,
// pre-fills the input on next visit.
const KEY = "pressdent.admin.author"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (!this.hasInputTarget) return
    if (this.inputTarget.value) return
    const saved = localStorage.getItem(KEY)
    if (saved) this.inputTarget.value = saved
  }

  save() {
    const v = this.inputTarget.value.trim()
    if (v) localStorage.setItem(KEY, v)
  }
}
